module.exports = __webpack_public_path__ + "html/feedbacks-list_e4eb2203fe00ed402adea96b363236eb.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/feedbacks-list.html
// module id = JBV/
// module chunks = 5